import { render, staticRenderFns } from "./CurrencyPanel.vue?vue&type=template&id=a5c40aae&scoped=true&"
import script from "./CurrencyPanel.vue?vue&type=script&lang=js&"
export * from "./CurrencyPanel.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyPanel.vue?vue&type=style&index=0&id=a5c40aae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c40aae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VDivider,VImg,VToolbar})
